export function formatDepositDueDate(depositDueDate) {

    return new Date(depositDueDate?.replace(/-/g, "/") + " EST");
}
